import React from "react";
import FondoBici from "../images/fondobici.png";
import NotaBici from "../images/notabici.png";
import ActividadBici from "../images/actividadbici.png";

import Medios1 from "../images/medios1.png";
import Medios2 from "../images/medios2.png";
import Medios3 from "../images/medios3.png";
import Medios4 from "../images/medios4.png";
import Medios5 from "../images/medios5.png";
import Medios6 from "../images/medios6.png";
import Medios7 from "../images/medios7.png";
import Medios8 from "../images/medios8.png";
import Medios9 from "../images/medios9.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";

import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  contentLamina2: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
    background: theme.palette.secondary.main,
    padding: "2em",
  },
  actividadFondo: {
    backgroundImage: "url(" + FondoBici + ")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    minHeight: 500,
    width: "100%",
    marginTop: 40,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    "& p": {
      lineHeight: 1.5,
      maxWidth: 400,
    },
    marginBottom: "4em",
    [theme.breakpoints.down("xs")]: {
      backgroundSize: "100% auto",
      backgroundPosition: "bottom",
      "& p": {
        maxWidth: "100%",
      },
    },
  },

  actividad: {
    background: "#6a2c9138",
    border: "6px solid " + theme.palette.purple.main,
    "& p": {
      marginLeft: "1em",
    },
    marginBottom: "4em",
  },
  options: {
    borderBottom: "1px solid #ccc",
  },
  option: {
    color: theme.palette.blue.main,
    textAlign: "right",
  },
  actividadContent: {
    maxWidth: 800,
  },
  bloqueRojo: {
    color: "#fff",
    padding: "0.5em 1em",
    maxWidth: 500,
    marginRight: "2em",
  },
}));

const Lamina11 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 11: Los medios de transporte"
        meta={[
          {
            property: "og:title",
            content: "Lámina 11: Los medios de transporte",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "Los medios de transporte son vehículos que nos permiten desplazarnos dentro o fuera de una localidad.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="11" color="primary" />
      <Container maxWidth="md" className={classes.contentLamina}>
        <Title title="LOS MEDIOS DE TRANSPORTE" color="primary" />
        <p>
          Los medios de transporte son vehículos que nos permiten desplazarnos
          dentro o fuera de una localidad o, incluso, trasladarnos de un país a
          otro. Algunos sirven para el transporte de personas y otros para
          trasladar productos. Los hay terrestres, marítimos y aéreos.
        </p>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="primary" />
        <p>
          <strong>
            A continuación se presentan algunos medios de transporte comunes.
          </strong>{" "}
          Marca con un aspa (X) aquellos en los que te hayas transportado alguna
          vez.
        </p>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={2} md={2} sm={3} xs={6}>
            <img src={Medios1} alt="Medios de transporte" />
          </Grid>
          <Grid item lg={2} md={2} sm={3} xs={6}>
            <img src={Medios2} alt="Medios de transporte" />
          </Grid>
          <Grid item lg={2} md={2} sm={3} xs={6}>
            <img src={Medios3} alt="Medios de transporte" />
          </Grid>
          <Grid item lg={2} md={2} sm={3} xs={6}>
            <img src={Medios4} alt="Medios de transporte" />
          </Grid>
          <Grid item lg={2} md={2} sm={3} xs={6}>
            <img src={Medios5} alt="Medios de transporte" />
          </Grid>
          <Grid item lg={2} md={2} sm={3} xs={6}>
            <img src={Medios6} alt="Medios de transporte" />
          </Grid>
          <Grid item lg={2} md={2} sm={3} xs={6}>
            <img src={Medios7} alt="Medios de transporte" />
          </Grid>
          <Grid item lg={2} md={2} sm={3} xs={6}>
            <img src={Medios8} alt="Medios de transporte" />
          </Grid>
          <Grid item lg={2} md={2} sm={3} xs={6}>
            <img src={Medios9} alt="Medios de transporte" />
          </Grid>
        </Grid>
        <p>
          ¿Cuáles de estos medios se usan más en tu comunidad o localidad?
          ¿Cuáles crees que contaminan más el ambiente? ¿Cuáles contaminan
          menos? ¿Por qué?
        </p>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <TitleSmall title="LA IMPORTANCIA DE LA BICICLETA" color="primary" />
        <p>
          Hoy, dada la crisis sanitaria, debemos repensar nuestros hábitos y
          reformular las formas de movilizarnos para así evitar saturar los
          medios de transporte masivos y mantener la distancia social
          recomendada. En este contexto, la bicicleta aparece como un medio de
          transporte con múltiples beneficios.
        </p>
        <Actividad color="primary" />
        <p>
          <strong>
            Une las palabras que describen cada beneficio de la bicicleta.
          </strong>
        </p>
        <img src={ActividadBici} alt="Medios de transporte" />
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <div className={classes.actividadFondo}>
          <div className={classes.bloqueRojo}>
            <img src={NotaBici} alt="Medios de transporte" />
          </div>
        </div>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-11.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          color="primary"
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 11: Los medios de transporte'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="El cuidado del ambiente"
        anteriorEnlace="/lamina-1-10"
        siguiente="Derechos y deberes de los ciudadanos"
        siguienteEnlace="/lamina-1-12"
      />
    </>
  );
};

export default Lamina11;
